import { Logo } from "@/components/Header";
import { WHATSAPP_DISPLAY } from "@/config/dtf";
import { whatsappLink } from "@/lib/dtf";
import { scrollToSection } from "@/lib/scroll";

const links = [
  { label: "Calculadora DTF Têxtil", href: "#calculadora" },
  { label: "Como enviar minha arte DTF", href: "#regras-arte" },
  { label: "Como funciona", href: "#como-funciona" },
  { label: "Dúvidas", href: "#duvidas" },
];

export const Footer = () => (
  <footer className="bg-black py-14 text-white sm:py-16">
    <div className="mx-auto max-w-7xl px-5 lg:px-8">
      <div className="grid gap-10 sm:grid-cols-3">
        <div>
          <span data-testid="footer-logo">
            <Logo dark className="h-14" />
          </span>
          <p className="mt-4 max-w-xs text-xs leading-relaxed text-white/50">
            Ferramentas gratuitas para quem trabalha com DTF têxtil, estamparia,
            personalização de camisetas e produção gráfica.
          </p>
        </div>

        <nav aria-label="Navegação do rodapé">
          <p className="num text-[11px] uppercase tracking-[0.24em] text-[#f58244]">
            Navegar
          </p>
          <ul className="mt-4 space-y-2.5">
            {links.map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection(l.href);
                  }}
                  className="text-sm text-white/70 transition-colors hover:text-white"
                >
                  {l.label}
                </a>
              </li>
            ))}
            <li>
              <a
                href={whatsappLink("Olá! Vim pelo ClickDTF.")}
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-white/70 transition-colors hover:text-white"
              >
                Envie sua arte agora
              </a>
            </li>
          </ul>
        </nav>

        <div>
          <p className="num text-[11px] uppercase tracking-[0.24em] text-[#f58244]">
            Contato
          </p>
          <a
            href={whatsappLink("Olá! Vim pelo ClickDTF.")}
            target="_blank"
            rel="noopener noreferrer"
            className="num mt-4 block text-base font-semibold text-white"
          >
            {WHATSAPP_DISPLAY}
          </a>
          <p className="mt-4 text-xs leading-relaxed text-white/40">
            Este site respeita a LGPD (Lei nº 13.709/2018). Não exigimos
            cadastro e não armazenamos os dados informados na calculadora — os
            cálculos acontecem no seu próprio navegador.
          </p>
        </div>
      </div>

      <div className="mt-12 flex flex-col gap-3 border-t border-white/10 pt-6 sm:flex-row sm:items-center sm:justify-between">
        <p data-testid="footer-copyright" className="text-xs text-white/40">
          © {new Date().getFullYear()} ClickDTF — clickdtf.com.br. Todos os
          direitos reservados.
        </p>
        <p className="text-xs text-white/40">
          Os valores exibidos são estimativas e não constituem orçamento final.
        </p>
      </div>
    </div>
  </footer>
);
